import { render, staticRenderFns } from "./BudgetViewMentor.vue?vue&type=template&id=6bc407b9&"
import script from "./BudgetViewMentor.vue?vue&type=script&lang=js&"
export * from "./BudgetViewMentor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports